import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

export const API_URL = `${URL}/api/properties`;

// Fetch all properties
export const fetchProperties = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const countByStatus = async () =>{
    try {
        const response = await axiosInstance.get(`${API_URL}/count-by-status`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const searchProperty = async ({propertyNumber}) =>{
    try {
        const response = await axiosInstance.get(`${API_URL}/properties/${propertyNumber}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateProperty = async ({id,payload}) => {
  try {
    const response = await axiosInstance.put(`/api/properties/${id}`,payload);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteProperty = async (id) =>{
  try {
    const response = await axiosInstance.delete(`/api/properties/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const addProperty = async (formData) =>{
  try {
    const response = await axiosInstance.post('/api/properties',formData);
    return response.data;
  } catch (error) {
    throw error
  }
}